function formatParams(obj: any = {}) {
  return Object.keys(obj)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
    .join("&");
}

export const imageupload = function () {
  return {
    "access-token": window.localStorage.getItem("assets-token-web"),
    "app-code": "WEB",
  };
};

export function getUrl(params: any = undefined) {
  let url = "/api/cmdb-template/oss/file/upload-file";
  if (import.meta.env.MODE === "development") {
    url = "/dev-api" + url;
  }

  if (params) {
    const queryString = formatParams(params);
    if (queryString) {
      url += `?${queryString}`;
    }
  }
  return url;
}

export function getUrl2(params: any = undefined) {
  let url = "/api/cmdb-template/oss/file/upload";
  if (import.meta.env.MODE === "development") {
    url = "/dev-api" + url;
  }

  if (params) {
    const queryString = formatParams(params);
    if (queryString) {
      url += `?${queryString}`;
    }
  }
  return url;
}
